import React from 'react';
import { DialogWindow } from '../DialogWindow';
import { ModalWindowTypes } from '../ModalWindow';

interface ISwitchDialogWindows {
  errorMessage?: string | React.ReactNode;
  errorTitle?: string | React.ReactNode;
  errorIcon?: React.ReactNode;
  isCompleted: boolean;
  isError: boolean;
  isLoading: boolean;
  loadingMessage?: string | React.ReactNode;
  loadingTitle?: string | React.ReactNode;
  loadingIcon?: React.ReactNode;
  onCloseClick: () => void;
  onRetryClick?: () => void;
  successMessage?: string | React.ReactNode;
  successTitle?: string | React.ReactNode;
  successIcon?: React.ReactNode;
  modalUiType?: ModalWindowTypes;
  children?: React.ReactNode;
}

export const SwitchDialogWindows: React.FC<ISwitchDialogWindows> = ({
  children,
  errorMessage,
  errorTitle,
  isCompleted,
  isError,
  isLoading,
  loadingMessage,
  loadingTitle,
  onCloseClick,
  onRetryClick,
  successMessage,
  successTitle,
  errorIcon,
  loadingIcon,
  successIcon,
  modalUiType,
}) => {
  switch (true) {
    case isLoading:
      return (
        <DialogWindow
          data-test-id={'processing'}
          type="processing"
          title={loadingTitle}
          message={loadingMessage}
          icon={loadingIcon}
          modalUiType={modalUiType}
        />
      );
    case isCompleted && !isError:
      return (
        <DialogWindow
          data-test-id={'success'}
          type="success"
          title={successTitle}
          message={successMessage}
          onClose={onCloseClick}
          icon={successIcon}
          modalUiType={modalUiType}
        />
      );
    case isCompleted && isError:
      return (
        <DialogWindow
          data-test-id={'error'}
          type="error"
          title={errorTitle}
          message={errorMessage}
          onClose={onCloseClick}
          onRetry={onRetryClick}
          icon={errorIcon}
          modalUiType={modalUiType}
        />
      );
    default:
      return <>{children}</>;
  }
};
